import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';

import EventEditDeleteConfirmContent from './event-edit-delete-confirm-content';

import * as recurrence from '../../../constants/recurrence-constants';

const EventEditDeleteConfirmModal = ({ rootContainer, isOpen, eventItem, confirmationActionType, handleModalOk, handleModalCancel }) => {
  const [title, setTitle] = useState(null);
  const [confirmType, setConfirmType] = useState(recurrence.EDIT_EVENT_TYPES.THIS);

  useEffect(() => {
    if (confirmationActionType && eventItem) {
      setTitle(
        confirmationActionType === recurrence.CONFIRM_ACTION_TYPES.DELETE
          ? `Delete recurring event. Are you sure you want to delete '${eventItem.subject}' event?`
          : confirmationActionType === recurrence.CONFIRM_ACTION_TYPES.EDIT
            ? `Edit recurring event '${eventItem.subject}`
            : null,
      );
    }
  }, [confirmationActionType, eventItem]);

  const handleOk = () => {
    setConfirmType(recurrence.EDIT_EVENT_TYPES.THIS);
    handleModalOk(confirmationActionType, eventItem, confirmType);
  };

  const handleCancel = () => {
    setConfirmType(recurrence.EDIT_EVENT_TYPES.THIS);
    handleModalCancel();
  };

  return (
    <Modal
      title={title}
      getContainer={rootContainer}
      open={isOpen}
      width={500}
      onOk={handleOk}
      onCancel={handleCancel}
      destroyOnClose={true}
      maskClosable={false}
      closable={false}
    >
      <EventEditDeleteConfirmContent confirmType={confirmType} onChangeType={setConfirmType} />
    </Modal>
  );
};
export default EventEditDeleteConfirmModal;
